import React, { memo } from 'react';
import { useFAQs } from '../../api/requests';
import FAQList from '../MovingPage/FAQ';

export interface FAQsProps {
  city: 'nyc' | 'brooklyn' | 'manhattan' | 'queens';
}

function FAQs({ city }: FAQsProps) {
  const { data, isLoading, error } = useFAQs(city);

  if (isLoading || error) return null;

  return (
    <section className="how_it_works container" style={{ paddingBottom: 0 }}>
      <FAQList faqs={data} />
    </section>
  );
}

export default memo(FAQs) as unknown as React.ComponentType<FAQsProps>;
